var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMingcute2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.464 15.878C2.798 15.213 3.224 14.094 4.126 14.006L4.241 14L20 14C20.2549 14.0003 20.5 14.0979 20.6854 14.2728C20.8707 14.4478 20.9822 14.6869 20.9972 14.9414C21.0121 15.1958 20.9293 15.4464 20.7657 15.6418C20.6021 15.8373 20.3701 15.9629 20.117 15.993L20 16L6.414 16L8.707 18.293C8.88635 18.473 8.99047 18.7144 8.99823 18.9684C9.00598 19.2223 8.91679 19.4697 8.74875 19.6603C8.58072 19.8508 8.34645 19.9703 8.09353 19.9944C7.8406 20.0185 7.58799 19.9454 7.387 19.79L7.293 19.707L3.463 15.877L3.464 15.878ZM3 8.99999C3.00003 8.75506 3.08996 8.51866 3.25271 8.33562C3.41547 8.15259 3.63975 8.03565 3.883 8.00699L4 7.99999L17.586 7.99999L15.293 5.70699C15.1137 5.52704 15.0095 5.28556 15.0018 5.03161C14.994 4.77766 15.0832 4.53028 15.2512 4.33972C15.4193 4.14915 15.6536 4.02969 15.9065 4.0056C16.1594 3.9815 16.412 4.05458 16.613 4.20999L16.707 4.29299L20.537 8.12299C21.202 8.78699 20.776 9.90599 19.874 9.99399L19.759 9.99999L4 9.99999C3.73478 9.99999 3.48043 9.89464 3.29289 9.7071C3.10536 9.51956 3 9.26521 3 8.99999Z",
    fill: "#212022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcute2Line);
export default __webpack_public_path__ + "static/media/mingcute-2line.0c501f2bebba9aa16c875c5c3dc0b831.svg";
export { ForwardRef as ReactComponent };